/**
 * IC proxies IWM errors as `{ message, detail }`. Show `detail.error` (or
 * `detail.code`) to operators — the generic message is not enough (IC-054).
 */
export function formatIwmProxyError(e: unknown, fallback: string): string {
  const data = (e as { response?: { data?: { message?: string; detail?: unknown } } })?.response?.data;
  const detail = data?.detail;
  if (typeof detail === 'string' && detail.trim()) return detail.trim();
  if (detail && typeof detail === 'object') {
    const d = detail as { error?: string; message?: string; code?: string };
    const text = String(d.error || d.message || '').trim();
    if (text) return text;
    if (d.code) return String(d.code);
  }
  const msg = String(data?.message || '').trim();
  return msg || fallback;
}
